import { ITransactionCategory } from "../@types/finance";

/**
 * Transaction categories that are no longer valid for bank transactions.
 *
 * Sales activity lives in the Dispense module: in-app dispense payments and
 * refunds are recorded against the sale (see the Sales pages), not as bank
 * transactions. The category rows still exist in the database so historic
 * records keep their labels — they are just hidden from anywhere a user picks
 * a category for a bank transaction.
 */
export const SALES_ONLY_CATEGORY_CODES = ["TILL_INCOME"];

/**
 * Categories a user may assign to, filter by, or build rules against.
 *
 * Use this for every category *picker*. Keep using the unfiltered list for
 * *lookups* (rendering the label of an already-assigned category), so legacy
 * rows still display correctly.
 */
export function selectableTransactionCategories(
  categories: ITransactionCategory[]
): ITransactionCategory[] {
  return categories.filter(
    (c) => !SALES_ONLY_CATEGORY_CODES.includes(c.code)
  );
}
